module.exports = __webpack_public_path__ + "img/bee-img-auth-sideimg4.67958d44.png";